import { computed, unref } from 'vue'
import { useDisplay } from 'vuetify'

export function useMobile() {
    const display = useDisplay();

    return computed(() => {
      return unref(display.mobile)
    });
}